/* eslint-disable @typescript-eslint/naming-convention */
import { SwipingCardType } from './../API_services/swiping-cards.interface';
import { PromoAnalyticsData } from 'src/app/shared/types/show-promo-analytics-options.interface';
import { TutorialService } from './../comunication_services/tutorial.service';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import amplitude from 'amplitude-js';
// import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics/ngx';
import { environment } from 'src/environments/environment';
import { JWTTokenService } from '../comunication_services/JWTToken.service';
import { SettingsDataService } from '../comunication_services/settingsData.sevice';
import { filter, take } from 'rxjs/operators';
import { SignMethod } from '../../enums/sign-method.enum';
import { PurchaseData } from '../../types/purchase-data.interface';
import { App } from '@capacitor/app';
import { ShowRegistrationFormData } from '../auth/show-registration-form-data';
import { PurchaseItemType } from '../../enums/purchase-item-type.enum';
import { OfferData } from '../../types/offer-data.interface';
import { PushNotificationSchema } from '@capacitor/push-notifications';
// eslint-disable-next-line @typescript-eslint/naming-convention
@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private isGameStarted = false;
  private isInit = false;
  buildVersion = environment.buildVersion;
  constructor(
    private _platform: Platform,
    // private ga: GoogleAnalytics,
    // private ym: NgxMetrikaService,
    private _tutorialService: TutorialService,
    private _tokenService: JWTTokenService,
    private _settingsDataService: SettingsDataService
  ) {}

  public init(): void {
    // console.log('android', this._platform.is('android'));
    // console.log('cordova', this._platform.is('cordova'));
    // console.log('ios', this._platform.is('ios'));
    // console.log('ipad', this._platform.is('ipad'));
    // console.log('iphone', this._platform.is('iphone'));
    // console.log('phablet', this._platform.is('phablet'));
    // console.log('tablet', this._platform.is('tablet'));
    // console.log('electron', this._platform.is('electron'));
    // console.log('pwa', this._platform.is('pwa'));
    // console.log('mobile', this._platform.is('mobile'));
    // console.log('mobileweb', this._platform.is('mobileweb'));
    // console.log('desktop', this._platform.is('desktop'));
    // console.log('hybrid', this._platform.is('hybrid'));

    if(this.isInit){
      return;
    }
    this.isInit = true;

    amplitude.getInstance().init('11fb2e90e0cf1533c79d138072942a5a'); // initializes default instance of Amplitude client

    // initializes named instance of Amplitude client
    // const instance2 = amplitude.getInstance("instance").init("11fb2e90e0cf1533c79d138072942a5a");
    if(this._platform.is('hybrid')){
      App.getInfo().then(res => {
        const prefix = this.buildVersion;
        amplitude.getInstance().setVersionName(prefix + ': ' + res.build);
      });
    }
    // this.ga
    //   .startTrackerWithId('3037886580')
    //   .then(() => {
    //     this.ga.trackView('test');
    //     // Tracker is ready
    //     // You can now track pages or set additional information such as AppVersion or UserId
    //   })
    //   .catch((e) => console.log('Error starting GoogleAnalytics', e));


  }

  public setUserId(userId: string) {
    amplitude.getInstance().setUserId(userId);
  }

  public setSplitTests(splitTests: any[]) {
    const identify = new amplitude.Identify().setOnce('split_tests', splitTests);
      amplitude.getInstance().identify(identify);
  }

  public setIsGuest(isGuest: boolean) {
    const identify = new amplitude.Identify().setOnce('is_guest', isGuest);
      amplitude.getInstance().identify(identify);
  }

  public gameStart(): void {
    if (!this.isGameStarted) {
      this.isGameStarted = true;
    }
  }

  public clickOnUpdateApk(updateFrom: string, updateTo: string) {
    amplitude.getInstance().logEvent('Click on update APK', {updateFrom, updateTo});
  }

  public authorize(method: SignMethod, type: 'log_in' | 'sign_up') {
    amplitude.getInstance().logEvent(type, { method });
  }

  public tutorial(step: number | 'tinder', isLast: boolean): void {
    if(isLast){
      amplitude.getInstance().logEvent('tutorial_completed_step', { step });
    }
  }

  public showRegForm(data: ShowRegistrationFormData) {
    amplitude.getInstance().logEvent('Show Auth Form', { ...data.data });
  }

  public openMessage(messageData: { messageId: string; chatId: string }): void {
    // amplitude.getInstance().logEvent('open_message', {
    //   message: messageData.messageId,
    //   chat: messageData.chatId,s
    // });
  }

  public savePhoto(chatId, photoId): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }
    amplitude.getInstance().logEvent('save_photo', { chatId, photoId });
  }

  public saveVideo(chatId, photoId): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }
    amplitude.getInstance().logEvent('save_video', { chatId, photoId });
  }

  public unlockingChat(): void {
    amplitude.getInstance().logEvent('unlocking_chat');
  }

  public chatIsOffline(chatId: string, messageIndex): void {
    amplitude.getInstance().logEvent('chat_is_offline',  {chatId, messageIndex});
  }

  public openGallery(): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }
    amplitude.getInstance().logEvent('open_gallery');
  }

  public openShop(): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }
    amplitude.getInstance().logEvent('open_shop');
  }

  public openSettings(): void {
    amplitude.getInstance().logEvent('open_settings');
  }

  public skipOfflineModal(chatId: string, name: string, cost: number): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('skip_offline', {chatId, name, cost});
  }

  public openAllChats(): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }
    // amplitude.getInstance().logEvent('open_all_chats'); // Disabled coz many requests
  }

  public swipeModel(id: string, name: string, isLiked: boolean, chatType: SwipingCardType): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('swipe_model', {
      id,
      name,
      isLiked,
      chatType
    });
  }

  public cardsFirstMatch(id: string, name: string, isLiked: boolean, chatType: SwipingCardType) {
    amplitude.getInstance().logEvent('cards_first_match', {
      id,
      name,
      isLiked,
      chatType
    });
  }

  public swipeLimit(cardCount: number, gemsCount: number): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('swipe_limit', {
      cardCount,
      gemsCount
    });
  }

  public swipeMatchSucceed(id: string, productPrice: number, currencyType: string, type: any): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('swipe_match_succeed', {
      id,
      productPrice,
      currencyType,
      type
    });
  }
  public trialMatched(chatId: string): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('trial_chat_matched', {
      chatId
    });
  }

  public trialPurchaseModalAppeared(chatId: string, messagesCount: number): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('trial_purchase_modal_appeared', {
      chatId,
      messagesCount
    });
  }
  public trialPurchaseClickBuy(chatId: string, messagesCount: number): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('trial_purchase_click_buy', {
      chatId,
      messagesCount
    });
  }

  public openSwipingCardsPage(): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('open_swiping_cards_page');
  }

  public openChat(id: string, name: string): void {


    if (this._tutorialService.tutorialModeOn) {
      return;
    }


    amplitude.getInstance().logEvent('open_chat', { id, name });
  }


  public buyChatForSoft(id: string, name: string): void {


    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('Buy Chat For Soft', { id, name });
  }

  public clickOnPurchase(target: string, id: string, name: string, source: PurchaseItemType, offerType = ''): void {

    if (this._tutorialService.tutorialModeOn) {
      return;
    }
    amplitude.getInstance().logEvent('click_on_purchase', { target, id, name, source, offerType });
  }

  public openBonus(): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('open_bonus');
  }
  public showBonus(bonus: string): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('show_bonus', {bonus});
  }

  public getBonus(day: number, bonus?: string): void {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }

    amplitude.getInstance().logEvent('get_bonus', { bonus, day });
  }

  public confirmPurchaseModal(data: PurchaseData) {
    amplitude.getInstance().logEvent('confirm_purchase_modal', {...data});
  }

  public notEnoughFunds(
    transactionId: string,
    productPrice: number,
    productName: string
  ) {

    amplitude.getInstance().logEvent('not_enough_funds', {
      transactionId,
      productPrice,
      productName,
    });
  }

  public notAuthorizedInPurchase(id, source) {
    amplitude.getInstance().logEvent('not_authorized_purchase', {
      id,
      source
    });
  }

  public notEnoughFundsDismiss() {
    amplitude.getInstance().logEvent('not_enough_funds_dismiss');
  }

  public notEnoughFundsConfirm(eroUrl) {
    amplitude.getInstance().logEvent('not_enough_funds_confirm', {...eroUrl});
  }

  public paymentError(paymentMethod, transactionId, productName) {
    amplitude.getInstance().logEvent('Payment Error', {paymentMethod, transactionId, productName});
  }

  public payment(
    paymentMethod: string,
    transactionId: string,
    productPrice: number,
    productName: string,
    lotType: string,
    source: string,
    meta: string,
    offerType: string = ''
  ): void {

    amplitude.getInstance().logEvent('realPayment', {
      paymentMethod,
      transactionId,
      productPrice,
      productName,
      lotType,
      source,
      meta,
      offerType
    });

    const revenue = new amplitude.Revenue().setProductId(transactionId).setPrice(productPrice).setQuantity(1);
    amplitude.getInstance().logRevenueV2(revenue);
  }

  public quickMessaging(action: boolean) {
    amplitude.getInstance().logEvent('quick_messaging', {
      action,
    });
  }

  public music(action: 'on' | 'off') {
    amplitude.getInstance().logEvent('turn_music', { action });
  }

  public sounds(action: 'on' | 'off') {
    amplitude.getInstance().logEvent('turn_sounds', { action });
  }

  public logout() {

    amplitude.getInstance().logEvent('log_out');
  }

  public buyAdditionalContent(action: 'buy' | 'close', name: string) {
    if (this._tutorialService.tutorialModeOn) {
      return;
    }
    amplitude.getInstance().logEvent('buy_additional_content', { action, name });
  }

  public clickIdSet(clickId: string, partnerId: string) {
    try {
      const identify = new amplitude.Identify().setOnce('click_id', clickId).setOnce('partner_id', partnerId);
      amplitude.getInstance().identify(identify);
    } catch (e) {
      console.error('Analytics click id set error', e);
    }
  }

  public landingBehaviorSet(landingBehavior: string) {
    try {
      const identify = new amplitude.Identify().setOnce('landing_behavior', landingBehavior);
      amplitude.getInstance().identify(identify);
    } catch (e) {
      console.error('Analytics landing behavior set error', e);
    }
  }

  public trafficSourceSet(ts: string) {
    // DEPRECATED TODO remove all trsrc
    try {
      const identify = new amplitude.Identify().setOnce('traffic_source', ts);
      amplitude.getInstance().identify(identify);
    } catch (e) {
      console.error('Analytics traffic source set error', e);
    }
  }

  public utmSourceSet(utmSource: string, utmMedium: string, utmCampaign: string, utmTerm: string) {
    try {
      const identify = new amplitude.Identify()
        .setOnce('utm_source', utmSource)
        .setOnce('utm_medium', utmMedium)
        .setOnce('utm_campaign', utmCampaign)
        .setOnce('utm_term', utmTerm);
      amplitude.getInstance().identify(identify);
    } catch (e) {
      console.error('Analytics traffic source set error', e);
    }
  }

  public setPlatform() {
    const devicePlatform = this._platform.is('hybrid') ? 'apk' : 'web';
    try {
      const identify = new amplitude.Identify()
        .setOnce('host_platform', environment.buildVersion)
        .setOnce('device_patform', devicePlatform)
        .setOnce('user_patforms', this._platform.platforms());
      amplitude.getInstance().identify(identify);
    } catch (e) {
      console.error('Analytics set platforms error', e);
    }
  }

  private _preparePromoData(data: PromoAnalyticsData): string {
    const nameArr = [];
    if(data.section) {
      nameArr.push(data.section);
    }
    if(data.chatName) {
      nameArr.push(data.chatName);
    }
    if(data.placeInSection) {
      nameArr.push(data.placeInSection);
    }
    if(data.positionInChatList) {
      nameArr.push(data.positionInChatList);
    }
    if(data.messageIndex) {
      nameArr.push(data.messageIndex);
    }
    if(data.bannerSlide) {
      nameArr.push(data.bannerSlide);
    }

    const name = nameArr.join(' / ');
    return name;
  }

  private _getLinkParams(link): any {
    let linkParams;
    if(link) {
      const url = new URL(link);
      const params = new URLSearchParams(url.search);
      linkParams = Object.fromEntries(params.entries());
    } else {
      linkParams = {};
    }
    return linkParams;
  }

  public clickOnPromoWidget(data: PromoAnalyticsData) {
    const name = this._preparePromoData(data);

    const linkParams = this._getLinkParams(data.link);

    // promoCompany: string, name: string, positionInChatsList: number, bannerPlaced?: string

    this._settingsDataService.updateSettingsData.pipe(
      filter(res => res.id !== null),
      take(1)
    ).subscribe(res => {

      amplitude.getInstance().logEvent('click on promo', {
        userId: res.id,
        sessionid: this._tokenService.getToken(),
        promoCompany: data.promo,
        name,
        ...linkParams,
        ...data
      });
    });
  }

  public promoIsShown(data: PromoAnalyticsData) {
    const name = this._preparePromoData(data);
    const linkParams = this._getLinkParams(data.link);
    amplitude.getInstance().logEvent('Promo Is Shown', {promoCompany: data.promo, name, ...linkParams });
  }

  public clickOnDiscordLink(place = 'chats') {
    amplitude.getInstance().logEvent('click on Discord', {place});
  }

  public activatedPromoCode(promoCode: string) {
    amplitude.getInstance().logEvent('Activated Promo Code', {promoCode});
  }

  public clickOnResendEmail() {
    amplitude.getInstance().logEvent('Click on resend email');
  }

  public clickOnSubscribeToPush() {
    amplitude.getInstance().logEvent('Subscribe to Push');
  }

  public isBanned(chatId: string, name: string, messageIdx: number) {
    amplitude.getInstance().logEvent('User Is Banned', {chatId, name, messageIdx});
  }

  public clickOnUnban(chatId: string, name: string, messageId: number) {
    amplitude.getInstance().logEvent('Click on Unban btn', {chatId, name, messageId});
  }

  public unbanBoughtBySoft(chatId: string, coins: number) {
    amplitude.getInstance().logEvent('Unbun Bought By Soft', {chatId, coins});
  }

  public showGiftsModal(chatId: string, name: string) {
    amplitude.getInstance().logEvent('Show Gifts Modal', {chatId, name});
  }

  public buyGift(chatId: string, name: string, giftId: string) {
    amplitude.getInstance().logEvent('Buy Gift', {chatId, name, giftId});
  }

  public nicknameModalAppeared(place: string) {
    amplitude.getInstance().logEvent('Nickname modal appeared', {place});
  }

  public nicknameIsSet(nickname: string, place: string) {
    amplitude.getInstance().logEvent('Nickname set', {nickname, place});
  }

  public clickOnOver18() {
    amplitude.getInstance().logEvent('click_on_over_18');
  }

  public showOffer(offerdata: OfferData) {
    amplitude.getInstance().logEvent('show_offer', {...offerdata});
  }
  public nativePushReceived(notitfication: PushNotificationSchema){
    amplitude.getInstance().logEvent('Native Push Received', {...notitfication, ...notitfication?.data});
  }

  public nativePushActionPerformed(notitfication: PushNotificationSchema){
    amplitude.getInstance().logEvent('Native Push Action Performed', {...notitfication, ...notitfication?.data});
  }

  public webPushPermissionGranted(){
    amplitude.getInstance().logEvent('Web Push Permission Granted');
  }

  public webPushReceived(notification){
    amplitude.getInstance().logEvent('Web Push Received', {...notification});
  }

  public showNutakuAuthModal() {
    amplitude.getInstance().logEvent('Show Nutaku Auth Modal');
  }
}
